import { createAction, props } from '@ngrx/store';
import { Payments } from './payments.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records payments'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records payments success', 
    props<{ listData: Payments[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records payments failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state payments',
);